export enum NotificationTopic {
    PROGRESS = 'PROGRESS',
    REPORT_FINISHED = 'REPORT_FINISHED',
    REPORT_FAILED = 'REPORT_FAILED',
    COPY_VENUE_PROGRESS = 'COPY_VENUE_PROGRESS'
}
